<template>
	<div>

		<div v-if="ProcessPendingSlidesOpen">
			<process-pending-slides :collections="props.collections" :activeCollection="props.meta" :tags="props.tags"
									:pendingSlides="props.pendingSlides"
									:pendingSlidesCount="props.pendingSlidesCount"
									:open=ProcessPendingSlidesOpen @close="closeEditWindow()"
									:editSlide="selectedEditSlide">

			</process-pending-slides>
		</div>



		<div class=" mb-6 max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">

			<!-- Setting Card -->
			<!-- Includes pending slides, collection selection, search, and image size slider -->


			<SettingsCard
				:auth="props.auth"
				:currentCollection="props.meta"
				:collections="props.collections"
				:tags="props.tags"
				v-model:search="searchQuery"
				v-model:slideSize="chartSizing"
				v-model:selectedTags="selectedTags"
				v-model:tagMatchAsOR="tagMatchAsOR"
				:pendingSlideCount="props.pendingSlidesCount"
				@openProcessPending="ProcessPendingSlidesOpen = true"
			/>

		</div>


		<div v-if="props.slides.length === 0" class="z-10 lg:px-8 max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-2 gap-12">
<!--			<empty-state @new="$emit('newSlide')"></empty-state>-->
			<setup-guide :auth="props.auth" :pendingSlideCount="props.pendingSlidesCount"
						 @openProcessPending="ProcessPendingSlidesOpen = true"
			></setup-guide>

			<setup-f-a-qs/>
		</div>


		<div class=""
			:class="[Object.keys(selectedSlides).length > 0 ? 'mb-44' : '']">

			<div v-for="(slideTagCollection,tag,index) in slidesFiltered" :key="index" class="">

				<div class="flex items-baseline pt-2">
					<h2 v-if="tag" class="font-bold text-xl pb-3">{{ tag }}</h2>
					<div class="bg-white border border-gray-200 h-8 leading-8 ml-3 rounded-full shadow text-center text-gray-400 px-3">
						{{slideTagCollection.length}} slide{{ slideTagCollection.length === 1 ? '' : 's' }}
					</div>
					<div class="h-0.5 bg-gray-300 mx-8 rounded-2xl grow"></div>

				</div>

				<div class="group/tagGrid">

					<div :id="'tagGrid' + index"
						 class="grid gap-4 p-4 grid-flow-col overflow-x-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-transparent group-hover/tagGrid:scrollbar-thumb-gray-400"
						 :style="{ 'grid-auto-columns': chartSizing + '%'}"
						 @mousedown="beginScroll($event,index)"
						 @mousemove='handleScroll($event,index)'
						 @mouseup="stopScroll(index)"
						 @mouseleave='stopScroll(index)'
					>
						<div v-for="(slide,index) in slideTagCollection" :key="slide.id" >

							<div class="group/slide border shadow relative transition overflow-hidden w-full rounded-lg hover:outline hover:outline-gray-300 hover:outline-4"
									:class="[activeGridMouseDown ? 'cursor-grabbing' : 'cursor-pointer']"
									@click="selectSlide(slide)"
									data-heap="stage-slide">
								<button @click.stop="editSlide(slide)" type="button" class="z-20 invisible group-hover/slide:visible absolute right-4 top-2 flex p-1 rounded-md bg-indigo-300 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2">
									<svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
									</svg>

								</button>

								<img :src="slide.qualified_url" alt="" class="w-full" draggable="false">

							</div>

							<div class="">
								<div class="flex items-center">
									<svg v-if="slide.private" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-500 mr-2">
										<path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
									</svg>
									<h3 class="text-gray-900 font-semibold" :class="[chartSizing < 7  ? 'text-xs' : '', chartSizing < 13 ? 'text-sm' : '']">{{ slide.title }}</h3>
	<!--								<div v-for="(tag,index) in slide.tags" :key=index @click="selectTag(tag.name)"-->
	<!--									 class="border border-indigo-600 font-medium hover:opacity-100 inline-flex items-center ml-3 px-2 py-1 relative rounded-full text-xs whitespace-nowrap cursor-pointer"-->
	<!--									 :class="[selectedTags.includes(tag.name) ? 'bg-indigo-600 opacity-100 text-white hover:bg-indigo-700 drop-shadow-md' : 'bg-indigo-100 opacity-75 text-indigo-900 hover:bg-indigo-200']"-->
	<!--								>-->
	<!--									<span class="">{{ tag.name }}</span>-->
	<!--								</div>-->
								</div>
							</div>

						</div>
					</div>
				</div>


			</div>


			<div v-if="GeneratePresentationModalOpen">
				<GeneratePresentationModal
					:open=GeneratePresentationModalOpen
					:staged-slides="selectedSlides"
					@close="GeneratePresentationModalOpen = false"
				/>
			</div>



			<transition enter-active-class="transition ease-out duration-200"
						enter-from-class="transform opacity-0 translate-y-44"
						enter-to-class="transform opacity-100 scale-100"
						leave-active-class="transition ease-in duration-200"
						leave-class="transform opacity-100 scale-100"
						leave-to-class="transform opacity-0 translate-y-44">

			<!-- slide staging footer -->
			<div v-if="Object.keys(selectedSlides).length > 0" class="fixed inset-x-0 bottom-0" >
<!--				 style="box-shadow: 0px 0px 17px 2px rgb(55 48 163 / 15%), inset 0 0 0 0 rgb(0 0 0 / 0%);"-->
				<div class="">
					<div class="bg-white border-2 m-4 px-6 py-3 rounded-2xl shadow-2xl">
						<div class="flex items-center justify-between flex-wrap my-2">
							<div class="flex-1 flex items-center">

								<p class="font-googleBold inline text-2xl text-gray-900">
								Selected Slides <span class="bg-gray-100 rounded-xl m-2 text-sm py-1 px-2 text-gray-800 align-middle">{{selectedSlides.length}}</span>
								</p>

								<p data-heap="clear-slides" v-if="!removeSelectedSlidesPending" @click="removeSelectedSlidesPending = true" class="cursor-pointer hover:text-red-600 pl-6 text-gray-400 text-sm underline">clear slides?</p>
								<div v-else class="flex text-sm text-gray-400" >
									<p data-heap="clear-slides-confirm" class="pl-6 hover:text-red-600 underline cursor-pointer" @click="removeAllSelectedSlides">Confirm Clear</p>
									<p data-heap="clear-slides-cancel" class="pl-6 hover:text-gray-600  underline cursor-pointer" @click="removeSelectedSlidesPending = false">Cancel</p>
								</div>

							</div>



							<div class="ml-3">
								<button v-if="props.auth.user.isGAuthValid" data-heap="preview-slides" @click="GeneratePresentationModalOpen = true" class="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-800">

									Preview

									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 ml-2">
										<path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
										<path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
									</svg>

								</button>
								<div v-else-if="props.auth.user.hasGAuth" class="flex font-black items-center text-red-600 text-sm">
									You need to reauthenticate with Google before you can generate presentations.
									<a href="/start-google-auth" class="ml-4 flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-800">
										Reauthenticate
									</a>
								</div>
								<div v-else class="flex font-black items-center text-red-600 text-sm">
									You need to authenticate with Google before you can generate presentations.
									<a href="/start-google-auth" class="ml-4 flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-800">
										Start Authentication
									</a>
								</div>

							</div>


							<!-- filter up -->
							<div class="ml-3">
								<button data-heap="staging-visibility" @click="stagingMinimized = !stagingMinimized" type="button" class="flex p-2 rounded-md bg-gray-300 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white">
									<svg class="w-6 h-6 text-white" :class="{'rotate-180':stagingMinimized }" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 13l-7 7-7-7m14-8l-7 7-7-7"></path></svg>
								</button>
							</div>
						</div>

						<!-- slides here -->
						<transition enter-active-class="transition ease-out duration-200"
									enter-from-class="transform opacity-0 translate-y-44"
									enter-to-class="transform opacity-100 scale-100"
									leave-active-class="transition ease-in duration-200"
									leave-class="transform opacity-100 scale-100"
									leave-to-class="transform opacity-0 translate-y-44">

							<div v-if="!stagingMinimized" class="gap-3 grid p-3 -ml-4"
								style=" grid-auto-flow: column;
										grid-auto-columns: minmax(180px,1fr);
										overflow-x: auto;
										grid-template-columns: repeat(auto-fill,minmax(180px,1fr));
										"
								@drop="onDrop($event)"
								 @dragenter.prevent
								 @dragover.prevent
							>

								<!-- loop here-->
								<div v-for="(slide, index) in selectedSlides" :key="index" class="flex flex-shrink-0"
								@dragover="handleDragOver"
								@dragend="handleDragEnd"
								>

									<!-- Drop Indicator -->
									<div class="mr-3 bg-indigo-600 opacity-0 w-0.5 my-2 flex-shrink-0" :key="index" :id="index" data-drop-indicator></div>

									<div class="group border border-gray-300 rounded-lg relative hover:outline hover:outline-gray-300 hover:outline-4"
										 draggable="true"
										 @dragstart="startDrag($event,slide,index)"
									>
										<div class="absolute -top-3 -left-3">
											<span class="bg-indigo-600 rounded-xl text-sm  px-2 text-white align-middle">{{index + 1}}</span>
										</div>


										<button @click="removeSelectedSlide(index)" type="button" class="invisible group-hover:visible absolute right-4 top-2 flex p-2 rounded-md bg-gray-300 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2">
											<svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
										</button>
	<!--									<p class="!ml-0 -m-2 absolute bg-slate-500 border-gray-200 font-semibold inline-flex leading-5 px-2 right-0 rounded-full shadow text-slate-300 text-xs top-0"> Coming Soon </p>-->
										<img :src="slide.thumbnail_file_path" alt="" class=" rounded-lg">
									</div>
								</div>

								<!-- Drop Indicator for End -->
								<div class="mr-3 bg-indigo-600 opacity-0 w-0.5 my-2" :id="-1" data-drop-indicator></div>

							</div>
						</transition>

					</div>
				</div>
			</div>
			</transition>


		</div>

	</div>
</template>

<script setup>

import {computed, ref} from "vue";
import {Link, WhenVisible} from "@inertiajs/vue3";
import ProcessPendingSlides from "@/Pages/SlideRepo/Modals/ProcessPendingSlides";
import SetupGuide from "@/Pages/SlideRepo/SetupGuide";
import SettingsCard from "@/Pages/SlideRepo/SettingsCard.vue";
import GeneratePresentationModal from "@/Pages/SlideRepo/Modals/GeneratePresentationModal.vue";
import SetupFAQs from "@/Pages/SlideRepo/SetupFAQs.vue";

const ProcessPendingSlidesOpen = ref(false);

const props = defineProps({
	slides: Object,
	meta: Object,
	tags: Object,
	collections: Object,
	pendingSlides: Object,
	pendingSlidesCount: Number,
	auth: Object,
})
const chartSizing = ref(20);

// const copyElement = ref('');
// const copyNotificationVisible = ref(false);
// const lastClickedID = ref('');

const selectedTags = ref([]);
const searchQuery = ref('');
const tagMatchAsOR = ref(true); // OR vs AND in how tags are joined


const slidesFiltered = computed(() => {

	return Object.entries(props.slides).reduce((acc,[tagGroup,slidesWithinTag]) => {

		const filteredCategorySlides = slidesWithinTag.filter(slide => {
			const titleMatch = slide.title.toLowerCase().includes(searchQuery.value.toLowerCase());
			let tagMatch = true;

			if (selectedTags.value.length > 0) {

				if(tagMatchAsOR.value) {
					tagMatch = slide.tags.some(tag => selectedTags.value.includes(tag.name));
				} else {
					tagMatch = selectedTags.value.every(tag => slide.tags.some(slideTag => slideTag.name === tag));
				}
			}

			return titleMatch && tagMatch;
		});



		if (filteredCategorySlides.length > 0) {
			acc[tagGroup] = filteredCategorySlides;
		}

		return acc;
	}, {});
});



let selectedEditSlide = ref();

function editSlide(slide) {
	selectedEditSlide.value = slide;
	ProcessPendingSlidesOpen.value = true;

}

function closeEditWindow() {
	ProcessPendingSlidesOpen.value = false;
	selectedEditSlide.value = null;
}



// ------------ Drag and Drop in Staging ------------//
const startDrag = (event,slide,index) => {
	event.dataTransfer.dropEffect = 'move';
	event.dataTransfer.dropEffect = 'move';
	event.dataTransfer.setData('slideID',slide.id);
	event.dataTransfer.setData('slideIndex',index);
}

const onDrop = (event) => {
	// console.log('you dropped');
	const slideID = Number(event.dataTransfer.getData('slideID'));
	const slide = selectedSlides.value.find((slide) => slide.id === slideID);
	const startingIndex = event.dataTransfer.getData('slideIndex');

	const indicators = getIndicators();
	const el = getNearestIndicator(event,indicators);
	const endingIndex = el.element.id;

	if(startingIndex === endingIndex) { return } // this means move it no where
	if((endingIndex > startingIndex) && (Number(startingIndex) + 1 === Number(endingIndex))) { return } // this means it's moving no where since you didn't move it far enough back

	// first remove the slide
	removeSelectedSlide(startingIndex);

	const moveToEnd = endingIndex === "-1";

	// check if it was moving it to the end
	if(moveToEnd) {
		selectSlide(slide); // if so, just push it like now
	} else { // else push it into a specific index
		selectSlide(slide,Number(endingIndex) + (endingIndex > startingIndex ? -1 : 0));
		// we need to subtract 1 if end > start as this means you're moving right, so we don't want to double count
		// This is because each slide actually has two indexes, the before and After
		// when I move to the LEFT, because I'm deleting an index to the right, then I don't need to modify
		// however if I move to the RIGHT, because I'm also deleting the slide, I need to skip that index
	}

}
const highlightIndicator = (event) => {
	const indicators = getIndicators();
	clearHighlights(indicators);
	const el = getNearestIndicator(event,indicators);
	el.element.style.opacity = "1";
}

const clearHighlights = (elements) => {
	const indicators = elements || getIndicators();
	indicators.forEach((i) => {
		i.style.opacity = "0";
	})
}

const getIndicators = () => {
	return document.querySelectorAll('[data-drop-indicator]');
}

const getNearestIndicator = (event, indicators) => {

	// Convert NodeList to an Array
	const indicatorsArray = Array.from(indicators);

	return indicatorsArray.reduce(
		(closest, child) => {
			const box = child.getBoundingClientRect();
			const offset = event.clientX - (box.left + 60);


			if (offset < 0 && offset > closest.offset) {
				return {offset: offset, element: child}
			} else {
				return closest;
			}
		},
		{
			offset: Number.NEGATIVE_INFINITY,
			element: indicators[indicators.length - 1]
		}
	);
}

const handleDragOver = (event) => {
	highlightIndicator(event);
}

const handleDragEnd = () => {
	clearHighlights();

}


// ------------ Drag and Scroll in Grid ------------//

const activeGrid = ref(); // store the grid the user is in here
const activeGridMouseDown = ref(false);
let startX;
let scrollLeft;

const beginScroll = (event,index) => {
	// activeGrid.value = event.target; // set the element
	activeGrid.value = activeGrid.value = document.querySelector(`#tagGrid${index}`);
	activeGridMouseDown.value = true;
	startX = event.pageX - activeGrid.value.offsetLeft;
	scrollLeft = activeGrid.value.scrollLeft;
	activeGrid.value.style.cursor = "grabbing";
	activeGrid.value.style.opacity = "0.7";
}

const handleScroll = (event,index) => {
	event.preventDefault();
	if(activeGridMouseDown.value) {
		const x = event.pageX - activeGrid.value.offsetLeft;
		const walk = (x - startX) * 4; //scroll-fast
		activeGrid.value.scrollLeft = scrollLeft - walk;

	}
}

const stopScroll = (event) => {
	if(activeGrid.value) {
		activeGrid.value.style.opacity = "1";
		activeGrid.value.style.cursor = "default";
		activeGrid.value = null;
	}
	activeGridMouseDown.value = false;

}


// --------- Generate Presentation ---------//

const GeneratePresentationModalOpen = ref(false);

// --------- Staging Slides Actions ---------------//

let selectedSlides = ref([]);
let stagingMinimized = ref(false);

function selectSlide(slide, index) {
	// does this slide already exist? Prevent duplicate
	if(arguments.length ===1) {
		selectedSlides.value.push(slide);
	} else {
		selectedSlides.value.splice(index,0,slide)
	}
}


const removeSelectedSlidesPending = ref(false);

function removeSelectedSlide(index) {
	selectedSlides.value.splice(index,1);
	// selectedSlides.value = selectedSlides.value.filter((el) => { return el.id !== slide.id })
}

function removeAllSelectedSlides() {
	selectedSlides.value = [];
	removeSelectedSlidesPending.value = false;
}


</script>

<style>
input[type="range"] {
	outline: 0;
	border: 0;
	border-radius: 500px;

	max-width: 100%;
	transition: box-shadow 0.2s ease-in-out;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
	input[type="range"] {
		overflow: hidden;
		height: 1rem;
		-webkit-appearance: none;
		background-color: #ddd;
	}
	input[type="range"]::-webkit-slider-runnable-track {
		height: 1rem;
		-webkit-appearance: none;
		color: #444;
		transition: box-shadow 0.2s ease-in-out;
	}
	input[type="range"]::-webkit-slider-thumb {
		width: 1rem;
		-webkit-appearance: none;
		height: 1rem;
		cursor: ew-resize;
		background: #fff;
		box-shadow: inset 0 0 0 410px #4f46e5;
		border-top-right-radius: 1rem; /* 16px */
		border-bottom-right-radius: 1rem; /* 16px */
		border-radius: 1rem;

		transition: box-shadow 0.2s ease-in-out;
		position: relative;
	}

}
input[type="range"]::-moz-range-progress {
	background-color: #4f46e5;
}
input[type="range"]::-moz-range-track {
	background-color: #9a905d;
}
input[type="range"]::-ms-fill-lower {
	background-color: #4f46e5;
}
input[type="range"]::-ms-fill-upper {
	background-color: #9a905d;
}

</style>
